import { render, staticRenderFns } from "./receipt-card-partner-info.vue?vue&type=template&id=10ec6b4c"
import script from "./receipt-card-partner-info.vue?vue&type=script&lang=js"
export * from "./receipt-card-partner-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports